import { KeyValue } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportsUtilsService {

  constructor() { }

  getDebtorTypeOptions(): KeyValue<string, string>[] {
    return [
      { key: 'A', value: 'Report.Filters.All'},
      { key: 'C', value: 'Reports.Filters.Company' },
      { key: 'P', value: 'Reports.Filters.Person' }
    ]
  }

  getYearlyPeriodOptions(): KeyValue<number, string>[] {
    const periodOptions = [{ key: -1, value: 'Reports.Filters.Last12'}];
    const currentYear = new Date().getFullYear();
    const sixYearsAgo = currentYear - 6;
    for (let i = currentYear; i > sixYearsAgo; i--) {
      periodOptions.push({ key: i, value: i.toString() });
    }
    return periodOptions;
  }
}
